import React from 'react';
import classNames from 'classnames';

import css from './MainPanelHeader.module.css';

const MainPanelHeader = props => {
  const { rootClassName, className, children, noResultsInfo } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (!noResultsInfo && !children) return null;

  return (
    <div className={classes}>
      {children}
      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
